type WhiteLabelBundle = any;

type WhiteLabelModule = {
  default: WhiteLabelBundle;
};

const whiteLabelModules = import.meta.glob<WhiteLabelModule>("./*/index.ts", {
  eager: true,
});

export const WHITE_LABELS = Object.fromEntries(
  Object.entries(whiteLabelModules)?.map(([path, module]) => {
    const folderName = path.split("/")[1];
    return [folderName, module.default];
  })
) as Record<string, WhiteLabelBundle>;

export type WhiteLabelFolderName = keyof typeof WHITE_LABELS;

function getDefaultWhiteLabelFolder(): WhiteLabelFolderName {
  const [firstFolderName] = Object.keys(WHITE_LABELS) as WhiteLabelFolderName[];

  if (!firstFolderName) {
    throw new Error("[whiteLable] No white-label folders are registered.");
  }

  return firstFolderName;
}

function resolveWhiteLabelFolderFromEnv(): WhiteLabelFolderName {
  const rawFolderName = import.meta.env.VITE_WHITE_LABEL_FOLDER?.trim();
  console.log("rawFolderName", rawFolderName);

  if (!rawFolderName) {
    return getDefaultWhiteLabelFolder();
  }

  if (rawFolderName in WHITE_LABELS) {
    return rawFolderName as WhiteLabelFolderName;
  }

  throw new Error(
    `[whiteLable] Invalid VITE_WHITE_LABEL_FOLDER="${rawFolderName}". Available folders: ${Object.keys(
      WHITE_LABELS
    ).join(", ")}`
  );
}

export const CURRENT_WHITE_LABEL_FOLDER = resolveWhiteLabelFolderFromEnv();

function getCurrentWhiteLabel(folderName: WhiteLabelFolderName): WhiteLabelBundle {
  const whiteLabel = WHITE_LABELS[folderName];

  if (!whiteLabel) {
    throw new Error(
      `[whiteLable] Unknown white-label folder "${folderName}". Available folders: ${Object.keys(
        WHITE_LABELS
      ).join(", ")}`
    );
  }

  if (!whiteLabel.config?.app?.title) {
    throw new Error(`[whiteLable] Missing app title in "${folderName}/content.ts".`);
  }

  if (!whiteLabel.resources?.App_Url) {
    throw new Error(`[whiteLable] Missing App_Url in "${folderName}/resources.ts".`);
  }

  return whiteLabel;
}

export const CURRENT_WHITE_LABEL = getCurrentWhiteLabel(CURRENT_WHITE_LABEL_FOLDER);

export const WHITE_LABEL_CONFIG = CURRENT_WHITE_LABEL.config;
export const WHITE_LABEL_RESOURCES = CURRENT_WHITE_LABEL.resources;
export const App_Url = WHITE_LABEL_RESOURCES.App_Url;
export const AUTH_PERSIST_STORAGE_KEY = CURRENT_WHITE_LABEL.authPersistStorageKey;
export const applyWhiteLabelTheme = CURRENT_WHITE_LABEL.applyTheme;
export const getWhatsAppUrl = () => CURRENT_WHITE_LABEL.getWhatsAppUrl();
export const isImageLogoPath = (path?: string | null) => CURRENT_WHITE_LABEL.isImageLogoPath(path);
export const getChatbotName = () => WHITE_LABEL_CONFIG.contact?.chatbotName || "Chatbot";
